import React from "react";
import Svg, { Path } from "react-native-svg";

const Next = ({ strokeColor = "black", width = "", height = "" }) => {
  return (
    <Svg
      width={width ? width : "12"}
      height={height ? height : "20"}
      viewBox="0 0 12 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M2 2L10 10L2 18"
        stroke={strokeColor}
        stroke-opacity="0.56"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </Svg>
  );
};

export default Next;
